import React from 'react'
import { Route } from 'react-router-dom'
import PropTypes from 'prop-types'
import store from 'store'
import { TOKEN_KEY, USER_KEY } from '@/common/config'
import qs from 'qs'

const Authorized = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => {
        const query = qs.parse(props.location.search, {ignoreQueryPrefix: true})
        const { token, user = {} } = query
        // 参数携带token时，免登录
        if (token && token !== '') {
            // 将参数token, 用户信息写入本地存储
            store.set(TOKEN_KEY, token)
            store.set(USER_KEY, user)

            // 清除参数
            props.history.push(props.location.pathname)
            return null
        }

        if (store.get(TOKEN_KEY)) {
            return <Component {...props} />
        }

        window.location = '/#/user/login'
        return null
    }}/>
)

Authorized.propTypes = {
    component: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.element
    ])
}

Authorized.defaultProps = {
    component: () => null
}

export default Authorized
